module.exports = __webpack_public_path__ + "static/media/icon_send.5cf7b440.svg";